import { useQuery } from "@tanstack/react-query";
import { DeploymentHistory, emptyPage, Page } from "@/model";
import deploymentRepository from "@/repository/deploymentRepository";


const getData = async (id: number, page: number, size: number) => {
    const res = await deploymentRepository.findHistory(id, page, size);
    return res.data?.data || emptyPage<DeploymentHistory>();
};

export const useDeploymentHistoryPage = (agentId: number, page: number, size: number) => {
    return useQuery<Page<DeploymentHistory>>({
        queryKey: ["deployment-page", agentId, "page", page, "size", size],
        queryFn: async () => getData(agentId, page, size),
        retry: false
    });
};
